import { Box, Text } from '@shopify/polaris';
import { cls } from '~/utils';

interface WrapperActivatorProps {
  label?: string;
  onClick: () => void;
  disabled?: boolean;
  isChildren?: boolean;
  isLoading?: boolean;
}

export const WrapperActivator: React.FC<WrapperActivatorProps> = ({
  label,
  onClick,
  disabled,
  isChildren,
  isLoading,
}) => {
  return (
    <div
      onClick={() => {
        if (disabled) return;
        onClick();
      }}
      className={cls(
        {
          'cursor-default': disabled,
          'cursor-pointer': !disabled,
        },
        'relative',
      )}
    >
      {isChildren && (
        <div
          className="h-[38px] w-[12px] absolute left-[-12px] bottom-[10px]"
          style={{
            border: '1.5px solid #E3E3E3',
            borderRight: 'none',
            borderTop: 'none',
            borderBottomLeftRadius: '3px',
          }}
        />
      )}

      <Box
        background="bg-fill-transparent-secondary"
        paddingInline="200"
        paddingBlock="050"
        borderRadius="200"
      >
        <Text as="p" variant="bodySm" truncate>
          {isLoading ? 'Loading...' : label}
        </Text>
      </Box>
    </div>
  );
};
